import React from 'react';
import { View, Image } from 'react-native';
import Text from './CustomTextComponent';
import {images} from '../themes';

interface IEmptyListComponentProps{
    emptyListText:string;
}

const EmptyListCompnoent=(props:IEmptyListComponentProps)=>{
    return (
        <View style={{flex:1,justifyContent:"center",alignItems:"center",padding:10}}>
            <Image source={images.sadIcon} style={{height:40,width:40}}/>
            <Text type_of_six='three_six'>{props.emptyListText ?? ""}</Text>
        </View>
    )
}

export default EmptyListCompnoent;
